import { useState, useEffect } from 'react';
import { Carousel } from 'antd';
import { partners } from '../constants/AboutConstants';
import '../styles/PartnersComponent.css'
import 'antd/dist/reset.css';

const Partners = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const colWidth = 100 / partners.length;

  if (isMobile) {
    const slides = [];
    const len = partners.length;

    for (let i = 0; i < len; i++) {
      const first = partners[i % len];
      const second = partners[(i + 1) % len];
      slides.push([first, second]);
      i++; 
    }

    const repeatedSlides = [];
    let totalSlides = len; 
    for (let j = 0; j < totalSlides * 2; j++) {
      const first = partners[j % len];
      const second = partners[(j + 1) % len];
      repeatedSlides.push([first, second]);
      j++; 
    }

    return (
      <Carousel
        autoplay
        autoplaySpeed={3000}
        dots={false}
        className="partners-carousel"
        pauseOnHover={false}
        infinite
      >
        {repeatedSlides.map((pair, index) => (
          <div
            key={index}
            className="d-flex justify-content-center align-items-center"
          >
            {pair.map((src, subIndex) => (
              <div
                key={subIndex}
                style={{
                  width: '45%',
                  padding: '1rem',
                  textAlign: 'center',
                }}
              >
                <img
                  src={src}
                  alt={`partner-${index}-${subIndex}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    margin: '0 auto',
                  }}
                />
              </div>
            ))}
          </div>
        ))}
      </Carousel>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center flex-row flex-wrap partners-grid">
      {partners.map((src, index) => (
        <div
          key={index}
          style={{
            width: `${colWidth}%`,
            padding: '0.5rem',
            textAlign: 'center',
            filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.8))",
          }}
        >
          <img src={src} alt={`img-${index}`} style={{ width: '100%', height: 'auto' }} />
        </div>
      ))}
    </div>
  );
};

export default Partners;
